import { useCallback, useEffect, useState } from "react";
import { API_ENDPOINTS } from "../../api/config";
import { useNavigate } from "react-router-dom";

const RewardsList = ({ user, userPoints }) => {
  const [rewards, setRewards] = useState([]);
  const navigate = useNavigate();

  const getMyRewards = useCallback(() => {
    fetch(API_ENDPOINTS.REWARDS + `?userId=${user.id}`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch rewards");
        return res.json();
      })
      .then((rewardsData) => {
        const unredeemedRewards = rewardsData.filter(
          (reward) => reward.userId === user.id && reward.redeemed === false
        );
        setRewards(unredeemedRewards);
      })
      .catch((err) => {
        console.error("Error fetching rewards:", err);
        window.alert("Error loading rewards. Please try again.");
      });
  }, [user.id]);

  const redeemReward = (rewardId, pointsNeeded) => {
    if (userPoints < pointsNeeded) {
      window.alert("You don't have enough points to redeem this reward.");
      return;
    }

    fetch(API_ENDPOINTS.REWARDS + `/${rewardId}/redeem`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to redeem reward");
        return res.json();
      })
      .then(() => {
        window.alert("You have redeemed this reward!");
        getMyRewards();
      })
      .catch((err) => {
        console.error("Error redeeming reward:", err);
        window.alert("Error redeeming reward. Please try again.");
      });
  };

  useEffect(() => {
    getMyRewards();
  }, [getMyRewards]);

  return (
    <div className="rewards__container">
      <h2 className="section-title">Rewards</h2>
      <div className="flex flex-wrap justify-center rewards__row mt-4">
        {rewards.length === 0 ? (
          <div className="text-center">
            <img src="/assets/celebration.png" style={{ width: "150px", margin: "0 auto" }} alt="" />
            <h3>Hi {user.name}! You don't have any rewards to redeem yet.</h3>
            <p>Add rewards to redeem your points! 🎉</p>
            <button onClick={() => navigate("/rewards/new")}>
              Add New Reward
            </button>
          </div>
        ) : (
          rewards.map((reward) => (
            <div key={reward.id}>
              <div className="reward__card">
                <h5>{reward.rewardsDescription}</h5>
                <p>{reward.points} points</p>
                <button
                  onClick={() => redeemReward(reward.id, reward.points)}
                >
                  Redeem
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
export default RewardsList;
